import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { useIntersection } from 'react-use';
import {
  checkShowFaqs,
  fireScrollEvent,
  PDPDiscussionData,
} from '../../../Utils/productPageUtils';
import OfferCarousel from '../../Product/OfferCarousel';
import PdpCombo from '../../Product/PdpCombo';
import SaveComboCard from '../../Product/PdpCombo/SaveComboCard';
import HappinessPattern from '../../ProductNew/HappinessPattern/HappinessPattern';
import ProductDetail from '../../ProductNew/ProductDetail';
import MyloCertName from '../../ProductNew/ProductInfoNew/MyloCertName';
import MyloCertNameNew from '../../ProductNew/ProductInfoNew/MyloCertNameNew';
import Timer from '../../StoreHomePage/Timer';
import ConsultDoctor from '../ConsultDoctor/ConsultDoctor';
import MotherVideoReviews from '../FertilityTrustSection/MotherVideoReviews';
import {
  detergentFaqsData,
  diaperPdpIds,
  doctorReviewsData,
  faqsData,
  lactoFaqsData,
  lactoMamaPdp,
  motherReviewsData,
} from '../FertilityTrustSection/constant';
import NewTrustStrip from '../NewTrustStrip';
import PdpTrustSection from '../PdpTrustSection/PdpTrustSection';
import { showTrustSection } from '../PdpTrustSection/common';
import { beforeAfterData, reportsData } from '../PowerContent/constant';
import PowerContent from '../PowerContent/index';
import ProductAction from '../ProductAction';
import { ProductInfo, SummaryContainer } from '../ProductDetailNew/styled';
import { SkeletonBox } from '../Skeleton/styled';
// const AboutSection = dynamic(() => import("../../Product/AboutSection"), {
//     ssr: false,
// });
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { getScreenName } from '../../../Utils/helper';
import AboutSection from '../../Product/AboutSection';
import ProductPageFaqs from '../../ProductNew/ProductPageFaqs';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import OfferSection from '../../StrollerPage/StrollerContentData/OfferSection';
import AboutProductNew from '../ProductInfoNew/AboutProductNew';
import UniversalAccordion from '../../StoreHomePage/UniversalAccordion';
import { AccordionHeading } from '../../StoreHomePage/UniversalAccordion/styled';
import PdpVideoSection from './PdpVideoSection';
import VideoSection from '../../DiaperLandingPage/VideoSection';
import ImagesGrid from '../../DiaperLandingPage/ImagesGrid';
import BabyDiaperVideo from '../../DiaperLandingPage/BabyDiaperVideo';
import { DeskTopMobile } from '../ImageGallaryCarousel/styled';
import { InclTaxNew } from '../ProductDetail/styled';
import WhatsappBanner from './WhatsappBanner';
import { lactoBannerData, whatsappBanerData } from './constant';
import FormBottomPopUp from '../../FormBottomPopup';
import PdpNddSddStrip from '../../ProductNew/SddNdd';
import Modal from 'react-modal';
import { fireEvent } from '../../../Utils/fireEvent';
import { scrollableBottomSheet } from '../../../Utils/redirections';
import { ModalCrossbtn } from '../../ProductNew/TrustStrip/styled';
import { images } from '../../../Constants/ImageUrls';
import VariantBottomPopup from './VariantBottomPopup';
import { showNewReviewSection } from '../../StoreCategoryPage/common';
import Cookies from 'js-cookie';
import PrepaidXOff from '../OfferCarousel/PrepaidXOff';

const MoreProductInfo = dynamic(
  () => import('../MoreProductInfo/MoreProductInfo'),
  {
    ssr: false,
  },
);
const AplusMoreProdInfo = dynamic(
  () => import('../AplusMoreProdInfo/AplusMoreProdInfo'),
  {
    ssr: false,
  },
);
const SizeAndPacksCover = dynamic(
  () => import('../../Product/SizeAndPacksCover'),
);

const RatingReviews = dynamic(() => import('../../Product/RatingandReviews'), {
  ssr: false,
});
export default function WidgetsMergeCover(props) {
  const {
    productData,
    setAddedToCart,
    offerList,
    priceData,
    showLighteningDeal,
    showSizePopup,
    setShowSizePopup,
    userType,
    features,
    experimentUserType,
    showNewDiaperVariantUx,
    isWrapperPdp,
    showNewDiaperComboPdp,
    isFullScreenVideoEnabled,
    setIsFullScreenVideoEnabled,
    generalItemData,
    setCurrentVideoIndex,
    setShowFullScreenVideo,
    showFullScreenVideo,
    sddNddData,
  } = props;
  const ratingRef = useRef(null);
  const discussionRef = useRef(null);
  const descriptionRef = useRef(null);
  const scrolledToBottomReview = useRef(false);
  const scrolledToBottomDescription = useRef(false);
  const [showFadeEffect, setShowFadeEffect] = useState(false);
  const [showPowerContent, setShowPowerContent] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [openPackPopup, setOpenPackPopup] = useState(false);
  const [isVariantPopup, setIsVariantPopup] = useState(false);
  const isLactoPdp = lactoMamaPdp.includes(productData?.id);
  const ratingIntersection = useIntersection(ratingRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  });
  const discussionIntersection = useIntersection(discussionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  });
  const couponCodeOffers = productData?.couponCodeOffers;
  const [openWidgetOnClick, setOpenWidgetOnClick] = useState();

  useEffect(() => {
    if (ratingIntersection?.isIntersecting) {
      if (scrolledToBottomDescription.current === false) {
        fireScrollEvent('description_end', productData);
        scrolledToBottomDescription.current = true;
      }
    } else if (discussionIntersection?.isIntersecting) {
      if (scrolledToBottomReview.current === false) {
        fireScrollEvent('review_end', productData);
        scrolledToBottomReview.current = true;
      }
    }
  }, [ratingIntersection, discussionIntersection]);
  useEffect(() => {
    const showContent = productData?.id === 979 || productData?.id === 3953;
    setShowPowerContent(showContent);
  }, [productData?.id]);
  const isFertilityProduct = [3408, 3663, 3662].includes(productData?.id);
  const showAPlusPlusExp = [3433, 3434].includes(productData?.id);
  const isCarrierProduct = [3433, 3434].includes(productData?.id);
  const isDetergentProduct = [1097, 3907, 3961].includes(productData?.id);
  const isDetergentCleanserComboProduct = [3960].includes(productData?.id);
  const offerData = {
    offerTag: 'Limited time offer',
    offerName: 'Get Mylo Ovaluna Ovulation Test Kit - Pack of 5 for FREE',
    offerValid: 'Offer valid till stocks last',
    offerCode: 'KITFREE',
    offerImg:
      'https://images.myloapp.in/NestJsUploads/1707290823066-MicrosoftTeams-image-(40).webp',
    offerProducts:
      'This Kit helps with determining Fertile Days and Improving Chances of Conception',
  };
  const pregnancyKitOfferData = {
    offerTag: 'Limited time offer',
    offerName: 'Get Mylo Pregnancy Test Kit - Pack of 5 for',
    offerValid: 'Offer valid till stocks last',
    offerCode: 'FREEKIT',
    offerImg:
      'https://images.myloapp.in/NestJsUploads/1716198983027-MicrosoftTeams-image-(49).webp',
    offerProducts:
      'This Kit helps determining Pregnancy at home with 99% accuracy',
  };
  const term_ids = offerList?.map((coupon) => coupon.term_id).join(',');
  const impressionData = {
    category: 'impression_section_in_pdp',
    section_name: 'Offer section',
    section_id: '',
    deeplink_value: null,
    shape: '',
    card_ids: [],
    sku_id: productData?.id,
    support_variable: term_ids,
  };

  const faqsImpressionData = {
    category: 'impression_section_in_pdp',
    section_name: 'Faqs Section',
    sku_id: productData?.id,
  };
  useEffect(() => {
    setIsDesktop(isDesktopUser());
  }, []);

  const openChooseVariantPopup = () => {
    setOpenPackPopup(true);
  };

  const handleClose = () => {
    fireEvent({
      category: 'discard_popup',
      parent: 'diaper cart filler',
      screen_name: getScreenName(),
    });
    setOpenPackPopup(false);
    document.getElementsByTagName('body')[0].classList.remove('noScroll');
  };

  const BottomStylePopup = scrollableBottomSheet('', '', '-100px', '', 'auto');

  const renderGeneralItem = (element, index) => {
    switch (element?.itemType) {
      case 'TYPE_REELS':
        return (
          <LazyLoad height={300} offset={0}>
            <VideoSection
              generalItem={element}
              productId={productData?.id}
              data={element.items}
              sectionId={`videoSection_${productData?.id}`}
              isFullScreenVideoEnabled={isFullScreenVideoEnabled}
              setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
              showFullScreenVideo={showFullScreenVideo}
              setShowFullScreenVideo={setShowFullScreenVideo}
              setCurrentVideoIndex={setCurrentVideoIndex}
            />
          </LazyLoad>
        );
      case 'BANNER':
        if (element?.openForm) {
          return (
            <LazyLoad height={300} offset={0}>
              <FormBottomPopUp
                element={element}
                productId={productData?.id}
                productData={productData}
              />
            </LazyLoad>
          );
        }
    }
  };

  const showNewReviewView = showNewReviewSection(userType);

  useEffect(() => {
    const validDisplayStyle = productData?.variantOption?.find(
      (option) => option?.dispaly_style !== '1',
    );
    if (!productData?.variantOption?.length || !validDisplayStyle) {
      Cookies.set('variantSize', 0);
    }
  }, [productData?.id]);

  const showPrepaidXOff = [3839, 3840, 3841, 3842].includes(
    parseInt(productData?.id),
  );
  return (
    <SummaryContainer>
      <ProductInfo>
        {isFertilityProduct || showNewDiaperVariantUx ? (
          <DeskTopMobile desktop>
            <MyloCertNameNew
              productId={productData?.id}
              certName={productData?.brandName}
              desktop
            />
          </DeskTopMobile>
        ) : (
          <MyloCertName
            isFertilityProduct={isFertilityProduct}
            productId={productData?.id}
            certName={productData?.brandName}
          />
        )}
        <div className={showFadeEffect ? 'fadeInEffect' : ''}>
          <ProductDetail
            productData={productData}
            priceData={priceData}
            showLighteningDeal={showLighteningDeal}
            clinic={false}
            showToast={showToast}
            setShowToast={setShowToast}
            isFertilityProduct={isFertilityProduct}
            features={features}
            setOpenWidgetOnClick={setOpenWidgetOnClick}
            showNewDiaperVariantUx={showNewDiaperVariantUx}
            isWrapperPdp={isWrapperPdp}
            isLactoPdp={isLactoPdp}
            isDetergentProduct={isDetergentProduct}
            isDetergentCleanserComboProduct={isDetergentCleanserComboProduct}
          />

          {/* {couponCodeOffers && couponCodeOffers?.name ? (
                        <OfferStrip
                            text="Offer Applicable"
                            code={couponCodeOffers?.name}
                        />
                    ) : null} */}
          {/* {productData?.id === 979 && <AwardSectionTop />} */}
          {productData?.generalItems?.map((element, index) => {
            switch (element?.itemType) {
              case 'GENERAL_TIMER_MINI':
                return (
                  <Timer
                    data={element}
                    key={`timer_${index}`}
                    productData={productData}
                  />
                );
            }
          })}
        </div>
      </ProductInfo>
      {productData?.variantOption.length &&
      !productData?.isWebBundle &&
      !isFertilityProduct &&
      !isDetergentProduct ? (
        <SizeAndPacksCover
          showSizePopup={showSizePopup}
          setShowSizePopup={setShowSizePopup}
          productData={productData}
          setShowFadeEffect={setShowFadeEffect}
          setAddedToCart={setAddedToCart}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
        />
      ) : null}
      {showNewDiaperVariantUx && (
        <InclTaxNew style={{ marginTop: '7px' }}>
          M.R.P. (incl of all taxes). Additional Charges may apply on discounted
          prices
        </InclTaxNew>
      )}
      {productData?.comboProducts?.length > 0 &&
        !showNewDiaperVariantUx &&
        !isDetergentProduct && (
          <PdpCombo
            productData={productData}
            title={'SAVE MORE WITH COMBOS'}
            userType={userType}
          >
            <SaveComboCard
              comboData={productData?.comboProducts}
              productData={productData}
              userType={userType}
            />
          </PdpCombo>
        )}
      {offerList?.length > 0 || productData?.couponCodeOffers ? (
        false ? (
          // <ScrollWrapper data={impressionData} threshold={0.8}>
          //     <OfferSection
          //         isFertilityProduct={isFertilityProduct}
          //         offerData={pregnancyKitOfferData}
          //         productId={productData?.id}
          //     />
          // </ScrollWrapper>
          <></>
        ) : showPrepaidXOff ? (
          <PrepaidXOff />
        ) : (
          <ScrollWrapper data={impressionData} threshold={0.8}>
            <OfferCarousel
              offerList={offerList}
              productId={productData?.id}
              productPrice={productData?.price}
              couponCodeOffers={productData?.couponCodeOffers}
              showNewDiaperVariantUx={showNewDiaperVariantUx}
              userType={userType}
            />
          </ScrollWrapper>
        )
      ) : showPrepaidXOff ? (
        <PrepaidXOff />
      ) : offerList === null ? (
        <SkeletonBox height="154.4px" width="100%" desktopHeight={'162.4px'} />
      ) : (
        <></>
      )}
      <ProductAction
        productData={productData}
        setAddedToCart={setAddedToCart}
        showSizePopup={setShowSizePopup}
        showNewDiaperVariantUx={showNewDiaperVariantUx}
        userType={userType}
        openChooseVariantPopup={openChooseVariantPopup}
        isVariantPopup={isVariantPopup}
        showPrepaidXOff={showPrepaidXOff}
      />
      <Modal
        isOpen={openPackPopup}
        onRequestClose={handleClose}
        style={BottomStylePopup}
        preventScroll={true}
        bodyOpenClassName="noScroll"
        htmlOpenClassName="noScroll"
        closeTimeoutMS={500}
        className={{
          base: 'bottomSheetPack',
          afterOpen: 'bottomSheetPackOpen',
          beforeClose: 'bottomSheetProductClose',
        }}
      >
        <ModalCrossbtn
          onClick={handleClose}
          src={images.CrossWhite}
          alt="Variant Select Popup close"
        />
        <VariantBottomPopup
          productData={productData}
          showSizePopup={showSizePopup}
          setShowSizePopup={setShowSizePopup}
          setShowFadeEffect={setShowFadeEffect}
          setAddedToCart={setAddedToCart}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
          isVariantPopup={true}
          handleClose={handleClose}
          isDetergentProduct={isDetergentProduct}
          isFertilityProduct={isFertilityProduct}
        />
      </Modal>
      {sddNddData && (
        <PdpNddSddStrip
          sddNddData={sddNddData}
          productData={productData}
          userType={userType}
        />
      )}
      {productData?.comboProducts?.length > 0 &&
      (showNewDiaperVariantUx || isDetergentProduct) ? (
        <PdpCombo
          productData={productData}
          title={'SAVE MORE WITH COMBOS'}
          showNewDiaperVariantUx={showNewDiaperVariantUx || isDetergentProduct}
          userType={userType}
        >
          <SaveComboCard
            comboData={productData?.comboProducts}
            productData={productData}
            userType={userType}
          />
        </PdpCombo>
      ) : null}
      {/* {showTrustSection(productData?.id, userType) ? (
                <TrustStripPdp />
            ) : ( */}
      {generalItemData?.length
        ? generalItemData?.map((element, index) => {
            const item = renderGeneralItem(element, index);
            return item;
          })
        : null}
      <NewTrustStrip productData={productData} />
      {/* )} */}
      <HappinessPattern
        showOnMobile={showTrustSection(productData?.id, userType)}
      />
      {showPowerContent && (
        <PowerContent
          beforeAfterData={beforeAfterData}
          reportsData={reportsData}
          fromPdp={true}
          productId={productData?.id}
        />
      )}
      {/* <LazyLoad
                height={100}
                once
                offset={productData?.id == 280 ? 50 : 300}
            > */}
      {isCarrierProduct ? (
        <LazyLoad height={300} once offset={50}>
          <PdpVideoSection />
        </LazyLoad>
      ) : null}
      {/* "https://images.myloapp.in/NestJsUploads/1720426152104-1080x1920_DD_USPsFirst_Story-ezgif.com-gif-maker.webm" */}
      {showNewDiaperVariantUx || showNewDiaperComboPdp ? (
        <LazyLoad height={300} offset={0}>
          <BabyDiaperVideo
            noMargin={
              productData?.widgets?.length == 0 ||
              productData?.widgets?.[0]?.type?.key != 'media'
            }
            videoUrl={
              'https://images.myloapp.in/NestJsUploads/1720427233844-videoplayback.mp4'
            }
          />
        </LazyLoad>
      ) : null}
      {isLactoPdp && userType === 'A' ? (
        <WhatsappBanner paddingTop={'48%'} data={lactoBannerData} />
      ) : null}
      {showAPlusPlusExp && !isDesktop ? (
        <AboutProductNew
          experimentUserType={userType}
          productData={productData}
          descriptionRef={descriptionRef}
          showAPlusPlusExp={showAPlusPlusExp}
        />
      ) : !isFertilityProduct ? (
        <AboutSection
          productData={productData}
          descriptionRef={descriptionRef}
          openWidgetOnClick={openWidgetOnClick}
          showNewDiaperVariantUx={showNewDiaperVariantUx}
        />
      ) : null}
      {isLactoPdp ? <WhatsappBanner data={whatsappBanerData} /> : null}
      {showNewDiaperVariantUx || showNewDiaperComboPdp ? (
        <LazyLoad height={300} offset={0}>
          <ImagesGrid />
        </LazyLoad>
      ) : null}
      {/* <AppVideoStyling>
                <p className="heading">
                    Why 1 Million Moms Trust Mylo Diaper Pants
                </p>
                <StoreYTVideoSection
                    homeVideo={true}
                    data={{
                        youtubeLink:
                            "https://www.youtube.com/watch?v=Q8l4vxuGEeA",
                    }}
                    catPage={true}
                />
            </AppVideoStyling> */}
      {/* {isFertilityProduct && (
                <FertilityTrust
                    productData={productData}
                    imagesByUser={babyTrustData}
                    clothDiaper={false}
                    allReviews={false}
                    setShowHeader={null}
                />
            )} */}
      {isFertilityProduct && (
        <LazyLoad height={300} once offset={50}>
          <MotherVideoReviews
            productData={productData}
            data={motherReviewsData}
            clothDiaper={false}
            allReviews={false}
            aplus={true}
            heading={'Moms Who Made it Happen 🤱'}
            unique={'mother'}
            isFertilityProduct={isFertilityProduct}
          />
        </LazyLoad>
      )}
      {isFertilityProduct && (
        <LazyLoad height={300} once offset={50}>
          <MotherVideoReviews
            productData={productData}
            data={doctorReviewsData}
            clothDiaper={false}
            allReviews={false}
            aplus={true}
            heading={'Your Questions Answered'}
            unique={'doctor'}
            isFertilityProduct={isFertilityProduct}
          />
        </LazyLoad>
      )}
      {isFertilityProduct ? (
        <>
          <AccordionHeading>Frequently Asked Questions</AccordionHeading>{' '}
          <UniversalAccordion categoryAccordionData={faqsData} faq={true} />
        </>
      ) : null}
      {isLactoPdp || isDetergentProduct ? (
        <>
          <AccordionHeading>Frequently Asked Questions</AccordionHeading>{' '}
          <UniversalAccordion
            categoryAccordionData={
              isDetergentProduct ? detergentFaqsData : lactoFaqsData
            }
            faq={true}
          />
        </>
      ) : null}
      {productData?.form_url && !isFertilityProduct ? (
        <ScrollWrapper
          data={{
            category: 'impression_section_in_pdp',
            screen_name: getScreenName(),
            section_name: 'consultation',
            parent: `consult_now`,
            sku_name: productData?.name?.slice(0, 99),
            selling_price: productData?.price,
            sku_type: productData?.skuType,
            sku_id: productData?.id,
          }}
          threshold={0.8}
        >
          <ConsultDoctor
            isFertilityProduct={isFertilityProduct}
            productData={productData}
          />
        </ScrollWrapper>
      ) : null}
      {showTrustSection(productData?.id, userType) ? (
        <>
          <PdpTrustSection />
          <HappinessPattern />
        </>
      ) : null}
      {/* {isFertilityProduct ? (
                <LazyLoad height={300} once offset={50}>
                    <ExpertCarousel />
                </LazyLoad>
            ) : null} */}
      {isFertilityProduct ? (
        <AboutSection
          productData={productData}
          descriptionRef={descriptionRef}
          openWidgetOnClick={openWidgetOnClick}
          collapse={true}
        />
      ) : null}
      <a id="Rating" className="anchor" rel="nofollow"></a>
      <LazyLoad height={500} once offset={200}>
        <RatingReviews
          productData={productData}
          ratingRef={ratingRef}
          isFertilityProduct={isFertilityProduct}
          showNewReviewView={showNewReviewView}
        />
      </LazyLoad>
      {checkShowFaqs(userType) &&
      !showNewDiaperVariantUx ? null : PDPDiscussionData[productData?.id] ? (
        <ScrollWrapper data={faqsImpressionData} threshold={0.2}>
          <ProductPageFaqs productData={productData} />
        </ScrollWrapper>
      ) : null}
      {productData?.widgets && (
        <LazyLoad height={44} once offset={400}>
          <MoreProductInfo data={productData} />
        </LazyLoad>
      )}
      {productData?.manufacture_detail && (
        <LazyLoad height={44} once offset={400}>
          <AplusMoreProdInfo
            manufactureDetail={productData?.manufacture_detail}
          />
        </LazyLoad>
      )}
      {/* {showClinicData ? (
                <HealthPlan
                    clinicData={clinicData}
                    varientOption={productData?.variantOption}
                    healthDetailPopupOpen={healthDetailPopupOpen}
                    closeModal={closeModal}
                    formData={formData}
                />
            ) : null} */}
    </SummaryContainer>
  );
}
